import { render, staticRenderFns } from "./ConsentsInput.vue?vue&type=template&id=6d01b7fc"
import script from "./ConsentsInput.vue?vue&type=script&lang=js"
export * from "./ConsentsInput.vue?vue&type=script&lang=js"
import style0 from "./ConsentsInput.vue?vue&type=style&index=0&id=6d01b7fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports